import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { useContext, useEffect, useMemo, useState } from 'react'
import { functions, useFirestore } from '../../helpers/firebaseContext';
import { FileCard } from '../../components/file_card';
import getKycFiles from '../../helpers/getKycFiles';
import { Button, Grid, Group, Loader, Title, } from '@mantine/core';
import { Link } from 'react-router-dom';
import { CustomClaims, } from '../../types';
import { MyUserDataContext } from '../../contexts';
import { httpsCallable } from 'firebase/functions';

const ManualConsent = () => {
    const db = useFirestore();
    const [consentDocumentFiles, setConsentDocumentFiles] = useState([])
    const [displayedConsents, setDisplayedConsents] = useState([])
    const [loading, setLoading] = useState<number[]>([])
    const [loadingPage, setLoadingPage] = useState(false)
    const userData = useContext(MyUserDataContext);

    let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims;
    const approveConsent = httpsCallable<any, any>(functions, 'approveConsent');

    useEffect(() => {
        setLoadingPage(true)
        const consentDocRef = doc(db, "manual", "consent");

        const unsubscribe = onSnapshot(consentDocRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                console.log("Live consentDoc?.requires_approval ========>>", data?.requires_approval);
                setConsentDocumentFiles(data?.requires_approval);
            }
            else {
                setConsentDocumentFiles([]);
            }
            setLoadingPage(false)
        });

        // Clean up listener on unmount
        return () => unsubscribe();
    }, []);
    const getData = async () => {
        if (consentDocumentFiles?.length) {

            const updatedCustomersConestData: any = await Promise.all(
                consentDocumentFiles.map(async (customeObj: any) => {
                    const linkData = await getKycFiles(customeObj?.path, null) || [];
                    return {
                        ...customeObj,
                        linkData: linkData[0] ?? null
                    };
                })
            );
            console.log("updatedCustomersConestData ========>", updatedCustomersConestData);
            setDisplayedConsents(updatedCustomersConestData || []);

            // setConsentDocumentFiles(updatedCustomersConestData)
        }
        else {
            setDisplayedConsents([]);

        }
    }
    useEffect(() => {


        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consentDocumentFiles,]);

    const renderFileCards = useMemo(() => <Grid>

        {!!displayedConsents?.length ?
            <>
                {displayedConsents?.map((consentFile: any, idx: number) => {

                    return consentFile?.linkData ? <Grid.Col span={3}>

                        <FileCard disableDelete={true} key={consentFile.linkData?.name} linkData={consentFile?.linkData ?? {}}
                            customInfoDisplay={<Grid>
                                <Grid.Col span={12}>

                                    <Link to={`/customers/${consentFile?.customerID}`}>

                                        {`${consentFile.customerID} - ${consentFile.customerName}`}

                                    </Link>
                                </Grid.Col>
                                <Grid.Col span={12}>
                                    {!userClaims["kfh_rm"] && (Object.keys(consentFile?.linkData?.metadata?.customMetadata))?.includes("kfhConsent") && <Button
                                        loading={loading.includes(idx)}
                                        w={"100%"}
                                        mt={10}
                                        radius="md"
                                        variant="light"
                                        onClick={() => {

                                            let currentLoading = [...loading, idx];

                                            currentLoading = [...new Set(currentLoading)]
                                            setLoading(currentLoading);

                                            const approveConsentResult = approveConsent({ customerIDs: [consentFile.customerID] }).then(() => {
                                                setLoading(currentLoading.filter((loadingVal) => loadingVal !== idx));
                                            });

                                        }}

                                    >
                                        Approve Consent document
                                    </Button>}
                                </Grid.Col>
                            </Grid>}
                        />

                    </Grid.Col> : <>
                        Invalid file data
                    </>

                }
                )}
            </>
            : <>No Files to approve</>

        }




    </Grid>, [displayedConsents, loading, userClaims])
    return (
        <div>
            <Group justify="space-between" my={10}>
                <Title>KFH Consent Requests</Title>

            </Group>
            {loadingPage ? <><Loader /></> : renderFileCards}

        </div>
    )
}

export default ManualConsent